import * as React from 'react';
import InputMask from 'react-input-mask';
import { Slug } from '@fnv-core/utils';
import { FormControlProps } from '../interfaces/FormControlProps';
import { FormStylingHelpers } from './helpers/FormStylingHelpers';
import { FormControlHelpers } from './helpers/FormControlHelpers';
import { FormLabelHelpers } from './helpers/FormLabelHelpers';
import { KenticoValidatorUtils } from "../kentico/KenticoUtils";
import { LabelAndPopover } from './components/label-and-popover';
import { PropertyHelpers } from '../helpers/PropertyHelpers';

export interface MaskedInputState {
    dataSourceCounter: number;
    isLoading: boolean;
    isErrorLoading: boolean;
    hasFocus: boolean;
}

class MaskedInput extends React.Component<FormControlProps, MaskedInputState> {
    constructor(props: FormControlProps) {
        super(props);

        this.state = {
            dataSourceCounter: 0,
            isLoading: false,
            isErrorLoading: false,
            hasFocus: false
        };
    }

    componentDidMount = () => {
        const value = this.props.field.value,
            formikBag = this.props.formikBag,
            formFieldDefinition = this.props.formFieldDefinition;
        
        if (value !== '') {
            formikBag.setFieldTouched(formFieldDefinition.name, true, true);
        }
    }

    onInputFocus = (event) => {                
        this.setState({hasFocus : true});
    }

    onInputBlur = (event) => {
        if (event.persist) {
            event.persist();
        }
        this.setState({hasFocus : false}, () => {
            this.props.field.onBlur(event);
        });
    }

    render() {
        let formatChars = {
            '9': '[0-9]',
            a: '[A-Za-z]',
            '*': '[A-Za-z0-9]',
            '!': '[0-9_.,!"/$()-{}%?+]'
        };

        let mask = this.props.formFieldDefinition.mask;
        const value = this.props.field.value;

        // check optional enableMaskConditions
        if (this.props.formFieldDefinition.enableMaskConditions !== undefined) {
            if (!this.props.formFieldDefinition.enableMaskConditions.kenticoMacroFunction(
                    this.props.formController.form.fieldMapper, 
                    value, 
                    KenticoValidatorUtils)) {
                mask = "";
            }
        }

        const inputProperties = {
            // Input properties has everything needed to deal with manual input
            // It will load related data when a datasource is set
            ...FormControlHelpers.inputProperties(this),
            maskChar: null,
            formatChars,
            mask: mask,
            onFocus: this.onInputFocus,
            onBlur: this.onInputBlur,
            value: value,
            autoComplete: !!this.props.formFieldDefinition.disableAutoComplete ? "off" : 
                            this.props.formFieldDefinition.autoCompleteToken !== undefined ? this.props.formFieldDefinition.autoCompleteToken : ""
        };

        return (
            <div className={FormStylingHelpers.getFormGroupStyle(this.props) + ' form__section-input ' + Slug.fromString(this.props.formFieldDefinition.name) + '-maskedinput-form-group' }>
                <LabelAndPopover 
                    fieldId={PropertyHelpers.getFieldID(this.props)} 
                    label={FormLabelHelpers.getFieldLabel(this)}
                    explanation={this.props.formFieldDefinition.explanation}
                    hasPopover={this.props.formFieldDefinition.hasPopover}
                    isLoading={this.state.isLoading}                      
                ></LabelAndPopover>
                <div className="input-group">
                    <InputMask {...inputProperties} type="text" className={FormStylingHelpers.getInputStyle(this) + " " +
                        (!!this.state.hasFocus ? "has-focus" : "")                    
                    } />
                    <div className="input-group-append form-control--is-valid-indicator">
                        <div className="input-group-text">
                            <span className="icon icon-checkmark" />
                        </div>
                    </div>
                    {!this.state.hasFocus && FormControlHelpers.invalidFeedbackComponent(this)}
                </div>
            </div>
        );
    }
}

export { MaskedInput };
